import React,{useEffect} from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { FaSwimmer,FaSpa,FaWifi } from "react-icons/fa";
import { BsBellFill } from "react-icons/bs";
import { AiFillCar } from "react-icons/ai";
import { CgGym } from "react-icons/cg";
import { BiDrink,BiRestaurant } from "react-icons/bi";
import { MdAir } from "react-icons/md";

import {GiOfficeChair} from 'react-icons/gi';
import {AiOutlineFundProjectionScreen} from 'react-icons/ai';
import {AiOutlineWifi} from 'react-icons/ai';
import {MdOutlineKingBed} from 'react-icons/md';
import {BsSnow2} from 'react-icons/bs';
import {BiDish} from "react-icons/bi";
import {RiSurgicalMaskLine} from 'react-icons/ri';
import {GiElevator} from 'react-icons/gi';
import {GiAirplaneDeparture} from 'react-icons/gi';

import Aos from "aos";
import "aos/dist/aos.css";

import './Facilities.css';

function Facilities() {
    useEffect(() => {
        Aos.init({duration:3000});
      }, []);


    return (
        <Container data-aos='zoom-in' fluid style={{paddingTop:'40px', paddingBlock:'40px',background:'white'}} >
       
            <h2 className='Title' >Hotel Amenities</h2>
            <Row >
                <Col lg={4} md={4} sm={4} xs={6} className='facilitiesCont' >
                    <BiDish className='iconStyle' />
                        <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>24 Hrs Room Service</h4>
                 </Col>
                <Col lg={4} md={4} sm={4} xs={6} className='facilitiesCont'>
                     <AiOutlineFundProjectionScreen className='iconStyle' />
                     <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>Smart TV with OTTs</h4>
                 </Col>
                <Col lg={4} md={4} sm={4}  className='facilitiesCont'>
                     <FaWifi className='iconStyle' />
                     <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>High-Speed Free Wi-Fi</h4>
                 </Col>
                
            </Row>
            <Row>
                <Col lg={4} md={4} sm={4} xs={6} className='facilitiesCont' >
                    <RiSurgicalMaskLine className='iconStyle' />
                    <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>COVID Protocol</h4>
                 </Col>
                <Col lg={4} md={4} sm={4} xs={6} className='facilitiesCont' >
                    <AiFillCar className='iconStyle' />
                    <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>Free Parking</h4>
                </Col>
                <Col lg={4} md={4} sm={4} className='facilitiesCont'>
                     <GiElevator className='iconStyle' />
                     <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>Elevator</h4>
                </Col>
            </Row>
            <Row>
                <Col lg={4} md={4} sm={4} xs={6} className='facilitiesCont' >
                    <GiAirplaneDeparture className='iconStyle' />
                    <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>Airport Transfers</h4>
                 </Col>
                <Col lg={4} md={4} sm={4} xs={6} className='facilitiesCont' >
                    <BiRestaurant className='iconStyle' />
                    <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>24 Hrs Hot Water</h4>
                </Col>
                <Col lg={4} md={4} sm={4} className='facilitiesCont'>
                     <MdAir className='iconStyle' />
                     <h4 style={{fontFamily:'Muli,sans-serif',fontWeight:'lighter',fontSize:'18px'}}>Fully Air Conditioned</h4>
                </Col>
            </Row>
        </Container>
    )
}

export default Facilities
